import Heading from '@/components/heading/Heading';
import Footer from '@/pages/home/components/Footer';
import React from 'react';
import ContactUsForm from './components/contactUsForm';

const ContactUs = (): React.JSX.Element => {
  return (
    <>
      <Heading />
      <main id="main-content" role="main" tabIndex={-1}>
        <section>
          <ContactUsForm />
        </section>
      </main>
      <Footer />
    </>
  );
};

export default ContactUs;
